// export const blue = '#2BA7B4'
// export const charcoal = '#4F4F4F'
// export const grey = '#A9AEAF'
// export const brick = '#AB7974'
// export const salmon = '#EE6557'
// export const green = '#00b67a'

export const lightBlue = '#72cbcb'
export const lightCharcoal = '#a6a4a5'
export const lightGrey = '#d1d7d8'
export const lightBrick = '#eba8a3'
export const lightSalmon = '#d28f91'
export const lightGreen = '#90c48e'

// Soul of the harvest color theme
export const color1 = 'rgb(166, 183, 170)'
export const color2 = 'rgb(210, 169, 106)'
export const color3 = 'rgb(92, 110, 108)'
export const color4 = 'rgb(211, 157, 135)'
export const color5 = 'rgb(187, 113, 84)'
export const color6 = 'rgb(69, 124, 159)'

export const blue = color2
export const charcoal = color1
export const grey = color4
export const brick = color3
export const salmon = color5
export const green = color6

export const black = 'black'
export const white = 'white'

export const lighterColors = [
  lightBlue, lightCharcoal, lightGrey, lightBrick, lightSalmon, lightGreen
]

export const defaultColors = [
  color1, color2, color3, color4, color5, color6, // original
  ...lighterColors // 10% lighter
]

// export const defaultColors = [
//   blue, charcoal, grey, brick, salmon, green, // original
//   ...lighterColors // 10% lighter
// ]

export const lightSocialColors = [
  lightSalmon, lightBlue, lightGrey, lightBrick, lightCharcoal
]
export const defaultSocialColors = [
  color1, color2, color3, color4, color5, color6,
  ...lightSocialColors
]
